<mat-dialog-content>
  <div class="flex flex-col justify-center items-center">
    <h1 id="warning">{{ data.header }}</h1>
  </div>

  <h4 style="text-align: center" [innerHTML]="data.message"></h4>

  <div class="flex flex-row justify-end items-center space-x-2">
    <!--    <button (click)="declinePressed()"  id="declineButton" mat-dialog-close mat-raised-button-->
    <!--            matTooltip="Kehren Sie zu den Projekteinstellungen zurück">-->
    <!--      Abbrechen-->
    <!--    </button>-->
    <bic-button (click)="declinePressed()">Abbrechen</bic-button>

    <!--    <button *ngIf="holdable" (holdTime)="holdHandler($event)" appHoldable  id="deleteButton" mat-raised-button-->
    <!--            matTooltip="Verlassen und unwiderruflich löschen">-->
    <!--      <span>{{data.approveButtonName}}</span>-->
    <!--    </button>-->
    @if (holdable) {
      <bic-button (holdTime)="holdHandler($event)" appHoldable buttonType="white">
        {{ data.approveButtonName }}
      </bic-button>
    }
    <!--    <button *ngIf="!holdable" (click)="approvePressed()"  id="approveButton" mat-raised-button-->
    <!--            matTooltip="Bestätigen">-->
    <!--      <span>{{data.approveButtonName}}</span>-->
    <!--    </button>-->
    @if (!holdable) {
      <bic-button (click)="approvePressed()" buttonType="white">
        {{ data.approveButtonName }}
      </bic-button>
    }
  </div>
</mat-dialog-content>
